import { t, Trans } from "@web-monorepo/i18n/macro";
import { DDSLabelText } from "@web-monorepo/dds";
import { Board } from "src/pods/ideas/data/types";
import ExperienceCard from "./ExperienceCard";
import styles from "./Experiences.module.css";

const boardOrder = [
  "positive-thinking",
  "respect",
  "big-challenges",
  "moods-and-attitudes",
  "conundrums",
  "growth-mindset",
  "perseverance",
  "empathy",
  "mindfulness",
];

export type ExperiencesProps = {
  boards: Board[];
  mountPoint: string;
  classId: string;
};

export default function Experiences({ boards, mountPoint, classId }: ExperiencesProps) {
  return (
    <div className={styles.container}>
      <DDSLabelText level="md" variant="secondary" className={styles.title} as="h4">
        <Trans>Big Ideas</Trans>
      </DDSLabelText>
      <div className={styles.cards}>
        {boardOrder.map((slug) => {
          const board = boards.find((b) => b.slug === slug);
          if (slug === "conundrums") {
            return (
              <ExperienceCard
                key={"conundrums"}
                mojo={"https://static.classdojo.com/img/ideas_platform/activities/conundrums/conundrums.png"}
                href={`/apps/remote/${mountPoint}/${classId}/conundrums`}
                title={t`Conundrums`}
                description=""
              />
            );
          }
          if (board) {
            return (
              <ExperienceCard
                key={board.slug}
                mojo={board.image}
                href={`/apps/remote/${mountPoint}/ideas/${board.slug}`}
                title={board.title}
                description=""
              />
            );
          }
        })}
      </div>
    </div>
  );
}
